import Card from '../../../components/card/Card';
import P from '../../../components/texts/p/P';
import Modal from '../../../components/modal/modal';
import TextArea from '../../../components/textarea/TextArea';
import { useState } from 'react';

interface RejectApplicationModalProps {
  isOpen: boolean;
  onClose: Function;
  onSecondaryAction: Function;
  onPrimaryAction: Function;
  loadingPrimaryBtn?: boolean;
}

const RejectApplicationModal: React.FC<RejectApplicationModalProps> = ({
  isOpen,
  onClose,
  onSecondaryAction,
  onPrimaryAction: onPrimaryAction,
  loadingPrimaryBtn = false,
}) => {
  const [modalText, setModalText] = useState<string>('');

  const renderContent = () => {
    return (
      <Card>
        <P type='1' variant='neutral' withMargin={false}>
          Declinar una solicitud eliminará la documentación.
        </P>
        <P type='1' variant='danger' withMargin={false}>
          Esta acción no se puede deshacer
        </P>
        <Card margin={{ top: '3' }}>
          <TextArea
            placeHolder='Escribí los cambios que solicitás, o el motivo de la denegación.'
            maxLengthHelpText={false}
            onChange={(e) => setModalText(e.target.value)}
          ></TextArea>
        </Card>
      </Card>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={'Declinar solicitud'}
      primaryText='Declinar solicitud'
      primaryVariant='primary'
      secondaryVariant='secondary'
      onSecondaryAction={() => onSecondaryAction(modalText)}
      onPrimaryAction={() => onPrimaryAction(modalText)}
      children={renderContent()}
      loadingPrimaryBtn={loadingPrimaryBtn}
    />
  );
};

export default RejectApplicationModal;
